<template>
  <div class="header-message">
    <a-icon type="bell" />
  </div>
</template>

<script>
export default {
  name: 'HeaderSelect',
  data () {
    return {}
  },

  methods: {}
}
</script>

<style scoped lang="less">
.header-message {

}
</style>
